import { useQuery, UseQueryOptions } from 'react-query';
import { AxiosError } from 'axios';
import {
  InsuranceVerificationAdapterService,
  GetPayerConnectionDetailsRequest,
  GetPayerConnectionDetailsResponse,
  GetPayerMixAnalysisResponse,
  GetPayerMixAnalysisRequest,
} from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v2/insurance_verification_adapter.pb';
import { authorizedFetch } from 'helpers/utils';

export const useWiePayerConnectionStatusQuery = <T = GetPayerConnectionDetailsResponse>(
  request: GetPayerConnectionDetailsRequest,
  options?: UseQueryOptions<GetPayerConnectionDetailsResponse, AxiosError<any>, T>
) => {
  const query = useQuery({
    queryKey: [request.locationId, 'get-wie-payer-connection-status'],
    queryFn: () => {
      return InsuranceVerificationAdapterService.GetPayerConnectionDetailsByLocationId(
        authorizedFetch(),
        { locationId: request.locationId ?? '' }
      );
    },
    refetchOnWindowFocus: false,
    ...options,
    enabled: !!request.locationId && (options?.enabled ?? true),
  });

  return { query };
};

export const useWiePayerMixQuery = <T = GetPayerMixAnalysisResponse>(
  request: GetPayerMixAnalysisRequest,
  options?: UseQueryOptions<GetPayerMixAnalysisResponse, AxiosError<any>, T>
) => {
  const query = useQuery({
    queryKey: [request.locationId, 'get-wie-payer-mix'],

    queryFn: () => {
      return InsuranceVerificationAdapterService.GetPayerMixAnalysis(authorizedFetch(), {
        locationId: request.locationId ?? '',
      });
    },
    refetchOnWindowFocus: false,
    ...options,
    enabled: !!request.locationId && (options?.enabled ?? true),
  });

  return { query };
};
